import { FC, useMemo } from 'react';
import { FilterBlock, IFilterBlockState, IFilterItem } from '@cbridge-tools/filters-panel';
import { t } from 'i18next';
import { RuleValidity } from '@cbridge-tools/rules-data-grid';
import { rulesValidityFilterSelector } from '@cbridge-modules/rules-management-page';
import { useSelector } from '@cbridge-utils/react-redux';
import { RuleMissingEntitiesIcon, RuleOverriddenIcon, RuleSelfConflictingIcon } from '@cbridge-tools/icons';
import { ClearErrorInvalidFilterButton } from './ClearErrorInvalidFilterButton';
import { ErrorInvalid } from './ErrorInvalid';

export const ErrorInvalidFilter: FC<IFilterBlockState> = (props) => {
  const validityFilter = useSelector(rulesValidityFilterSelector);

  const items: IFilterItem[] = useMemo(() => {
    const map: Record<RuleValidity, Omit<IFilterItem, 'value'>> = {
      [RuleValidity.Error]: {
        label: t('text:rulesEditor.validityFilter.missingEntities'),
        Icon: RuleMissingEntitiesIcon,
      },
      [RuleValidity.Unused]: {
        label: t('text:rulesEditor.validityFilter.unused'),
        Icon: RuleOverriddenIcon,
      },
      [RuleValidity.Useless]: {
        label: t('text:rulesEditor.validityFilter.useless'),
        Icon: RuleSelfConflictingIcon,
      },
    };

    return Object.entries(map)
      .filter(([value]) => {
        const filter = validityFilter[value as RuleValidity];
        return filter?.count > 0 || filter?.isActive;
      })
      .map(([value, options]) => ({ value, ...options }));
  }, [validityFilter]);

  return (
    <FilterBlock
      label={t('text:rulesEditor.validityFilter.title')}
      clearFilterAction={<ClearErrorInvalidFilterButton />}
      items={items}
      FilterBlockItemComponent={ErrorInvalid}
      {...props}
    />
  );
};
